

<div class="_dialog-title">
	<div class="flex-grow-1 text-xl">{{'EX_PAYMENT_MODAL' | translate}}</div>
	<button mat-icon-button mat-dialog-close cdkFocusInitial>
		<mat-icon aria-label="Close Dialog">close</mat-icon>
	</button>
</div>


<div class="_dialog-content px-4 py-2">
	<div class="text-center" style="margin-bottom: 10px;padding: 10px 0"><img src="/assets/images/vendors/secured_by_cardconnect.png" /></div>
	<div id="google-payment-container" style="height: 50px"></div>
	<div id="apple-payment-container"></div>

	<!--<table class="table table-bordered">
		@for (message of log(); track message; let index = $index) {
			<tr>
				<td>{{index}}</td>
				<td>{{message}}</td>
			</tr>
		}
	</table>-->

	@if (error()) {
		<div class="alert alert-danger"><small>{{ error() }}</small></div>
	}

	@if (hasDigitalWallet()) {
		<hr class="_or">
	}

	<div class="alert alert-info" style="padding:10px">
		<div><b>Pay with card</b></div>
		<small>To complete your secure transaction, enter your credit card information below and click submit</small>
	</div>

	<div class="card-brands" aria-hidden="true">
		<mat-icon svgIcon="cc_visa_color"></mat-icon>
		<mat-icon svgIcon="cc_mastercard_color"></mat-icon>
		<mat-icon svgIcon="cc_amex_color"></mat-icon>
		<mat-icon svgIcon="cc_discover_color"></mat-icon>
	</div>

	<iframe id="ex_iframe" [src]="trustedIframeUrl" (load)="onFrameLoaded($event)"></iframe>
</div>


<div class="_dialog-actions p-4">
	<button mat-raised-button color="accent" class="lg main-continue-btn " type="button" (click)="applyCardPoint()" [disabled]="!data.token">
		<div class="_inner">
			<span>{{'Submit' | translate}}</span>
			<span>{{data.total | lcurrency}}</span>
			<div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
		</div>
	</button>
</div>




